import { render, staticRenderFns } from "./NoticiaDetalle.vue?vue&type=template&id=b87a1b74"
import script from "./NoticiaDetalle.vue?vue&type=script&lang=js"
export * from "./NoticiaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports